// extracted by mini-css-extract-plugin
export var askAiIcon = "_qe-9";
export var container = "_qe-0";
export var groupSeparator = "_qe-a";
export var highlight = "_qe-4";
export var resultIcon = "_qe-5";
export var resultItem = "_qe-7";
export var resultSubtitle = "_qe-3";
export var resultTitle = "_qe-2";
export var resultsList = "_qe-1";
export var searchGroup = "_qe-6";
export var selected = "_qe-8";